import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, INote } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-my-notes',
  templateUrl: './my-notes.component.html',
  styleUrls: ['./my-notes.component.scss']
})
export class MyNotesComponent implements OnInit {

  @Input() dashboard: IDashboardMidwifePayload;
  notes: Array<INote> = [];

  constructor() { }

  ngOnInit(): void {
    this.notes = this.dashboard.notes;
    this.notes = this.notes.slice(0 , 3);
  }

  updateNotes(note: INote){
    this.notes.pop();
    this.notes.unshift(note);
  }

}
